import { render, staticRenderFns } from "./service-virtuel-planning.vue?vue&type=template&id=fba94666"
import script from "./service-virtuel-planning.vue?vue&type=script&lang=js"
export * from "./service-virtuel-planning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports